export default __webpack_public_path__ + "static/media/People.230725c2.jpg";